import { style } from '@material-ui/system'

export const opacity = style({
  prop: 'opacity'
})

export const textTransform = style({
  prop: 'textTransform'
})

export const whiteSpace = style({
  prop: 'whiteSpace'
})
